export default {
  title: {
    id: 'performances_title',
    defaultMessage: 'Insights',
  },
  pageTitle: {
    id: 'performances_page_title',
    defaultMessage: 'Performances',
  },
  pageDescription: {
    id: 'performances_page_description',
    defaultMessage: 'Performances',
  },
  navigation: {
    id: 'performances_navigation_label',
    defaultMessage: 'Performances navigation',
  },
  tabHome: {
    id: 'insights_portal_tab_home',
    defaultMessage: 'Home',
  },
}
